module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/RS-24a18db83c0b16f79bc2a11fd0c96e75.png";